import {ApiClient} from './apiClient/apiClient';

const apiClient = new ApiClient();

export const getUsers = () => {
    return apiClient.get(`users`);
}

export const getUser = (id) => {
    return apiClient.get(`users/${id}`);
}

export const updateUser = (user) => {
    return apiClient.put(`users/${user.id}`, user);
}

export const deleteUser = (id) => {
    return apiClient.delete(`users/${id}`);
}

export const enableUser = (id) => {
    return apiClient.put(`users/${id}/enable`);
}

export const disableUser = (id) => {
    return apiClient.put(`users/${id}/disable`);
}

export const changePassword = (data) => {
    return apiClient.put(`users/${data.id}/password`, data);
}

// export const resetPassword = (id) => {
//     return apiClient.put(`users/${id}/reset-password`);
// }




